var NavToolbarContentComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./nav-toolbar-content.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./nav-toolbar-content.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { NavConstants } from "../nav.constants";
import { NavigationEnd, NavigationStart, Router } from "@angular/router";
import { Link } from "../../../shared/models/link.model";
import { AppControllerService } from "../../../app-controller.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { AppConfig } from "../../../app.config";
import { ModuleConfigService } from "../../../shared/services/module-config/module-config.service";
import { AutoUnsubPortal } from "../../../shared/decorators/autounsub-portal.decorator";
let NavToolbarContentComponent = class NavToolbarContentComponent {
    static { NavToolbarContentComponent_1 = this; }
    authService;
    router;
    appControllerService;
    changeDetectorRef;
    moduleConfigService;
    sideNavToggle = new EventEmitter();
    appTitle;
    $authenticated;
    headingLinks;
    showHeadings;
    notificationIsOn = false;
    activeRoute;
    headingRoutes;
    propertyLayersForModules;
    appConfigLoadedSub;
    constructor(authService, router, appControllerService, changeDetectorRef, moduleConfigService) {
        this.authService = authService;
        this.router = router;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.moduleConfigService = moduleConfigService;
        this.$authenticated = this.authService.$isAuthenticated;
    }
    static getLink(headingText, address, selectedSystemModuleID) {
        return new Link(headingText, AppRoutingConstants.createRouteToViewWithPrefixRouteSeparator(selectedSystemModuleID, address));
    }
    ngOnInit() {
        this.initializeHeadingLinks();
        this.addHeadingLinks();
        this.populateHeadingRoutes();
        this.setActivatedRoute();
        this.listenForRouteChanges();
        this.checkMapServicePropertyLayer();
        var appConfigLoadedSub = this.appControllerService.$configLoadedSubject.subscribe((loaded) => {
            if (loaded) {
                this.appTitle = AppConfig.settings.projectSettings.projectName;
            }
        });
    }
    isShowDiv(linkText) {
        if (linkText === NavConstants.PROPERTIES_HEADING_TEXT) {
            return !this.moduleConfigService.isCemeteryModule();
        }
        else if (linkText === NavConstants.LOCATION_HEADING_TEXT) {
            return this.moduleConfigService.isCemeteryModule();
        }
        else
            return true;
    }
    checkPropertyLayer(layerName) {
        let found = false;
        if (this.propertyLayersForModules) {
            this.propertyLayersForModules.forEach((layer) => {
                if (layer.moduleId === Number(this.appControllerService.selectedModuleID)
                    && layer.layerType === layerName) {
                    found = true;
                }
            });
        }
        return found;
    }
    toggleSideNav() {
        this.sideNavToggle.emit();
    }
    routeToUpdateProfile() {
        const url = `${AppConfig.settings.ids.issuer}/AccountManagement?url=${AppConfig.settings.ids.redirectUri}&appName=${AppConfig.settings.applicationAlias}&clientId=${AppConfig.settings.ids.clientId}`;
        window.open(url, "_self");
    }
    checkMapServicePropertyLayer() {
    }
    addHeadingLinks() {
        const selectedSystemModuleID = this.appControllerService.selectedModuleID;
        this.headingLinks.push(NavToolbarContentComponent_1
            .getLink(NavConstants.APPLICATIONS_HEADING_TEXT, "", selectedSystemModuleID), NavToolbarContentComponent_1
            .getLink(NavConstants.PROPERTIES_HEADING_TEXT, "", selectedSystemModuleID), NavToolbarContentComponent_1
            .getLink(NavConstants.LOCATION_HEADING_TEXT, "", selectedSystemModuleID));
        this.changeDetectorRef.markForCheck();
    }
    listenForRouteChanges() {
    }
    reactToRouteChanges(event) {
        if (event instanceof NavigationStart) {
            this.handleNavigationStart();
        }
        if (event instanceof NavigationEnd) {
            this.handleNavigationEnd(event);
        }
    }
    checkIfHeadingRoute(event) {
        return this.headingRoutes.some((headingRoute) => {
            return event.urlAfterRedirects.includes(headingRoute);
        });
    }
    clearHeadings() {
        this.headingLinks = new Array();
    }
    handleNavigationEnd(event) {
        this.activeRoute = event.urlAfterRedirects;
        this.showHeadings = this.checkIfHeadingRoute(event);
        if (this.showHeadings) {
            this.clearHeadings();
            this.addHeadingLinks();
        }
    }
    populateHeadingRoutes() {
    }
    setActivatedRoute() {
        this.activeRoute = this.router.routerState.snapshot.url;
    }
    initializeHeadingLinks() {
        this.showHeadings = false;
        this.headingLinks = new Array();
    }
    handleNavigationStart() {
        this.clearHeadings();
    }
    static ctorParameters = () => [
        { type: AuthService },
        { type: Router },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: ModuleConfigService }
    ];
    static propDecorators = {
        sideNavToggle: [{ type: Output }]
    };
};
NavToolbarContentComponent = NavToolbarContentComponent_1 = __decorate([
    Component({
        selector: "app-nav-toolbar-content",
        providers: [],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], NavToolbarContentComponent);
export { NavToolbarContentComponent };
